import { useMemo } from 'react'
import useIsMobile, { useIsSmallScreen } from '../../../hooks/useIsMobile'

const useIsMobileOrTablet = () => {
  const isMobile = useIsMobile()
  const isSmallScreen = useIsSmallScreen()
  return useMemo(() => isMobile || isSmallScreen, [isMobile, isSmallScreen])
}
export default useIsMobileOrTablet
